import * as React from 'react';
import styles from './index.less';
import { history, useParams } from 'umi';
import { connect } from 'dva';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil, FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FIcons from '@/components/FIcons';

interface FreezeStates {
  nodeName: string;
  freezeReason: string;
}

function Freeze() {
  const params = useParams<{ id: string }>();
  const [isOwner, set_isOwner] = React.useState<boolean>(true);
  const [nodeName, set_nodeName] = React.useState<FreezeStates['nodeName']>('');
  const [freezeReason, set_freezeReason] = React.useState<FreezeStates['freezeReason']>('');

  AHooks.useMount(() => {
    handleData();
  });

  AHooks.useUnmount(() => {

  });

  async function handleData() {
    const { data } = await FServiceAPI.Node.details({ nodeId: Number(params.id) });
    // console.log(data, 'DDDDDDDDDfo9iwekjlskdfjsdlkj');

    if ((data.status & 4) !== 4) {
      history.replace(FUtil.LinkTo.nodeManagement({ nodeID: Number(params.id) }));
      return;
    }

    set_nodeName(data.nodeName);
    set_freezeReason(data.freezeReason || '其他违法违规');
  }

  return (<div className={styles.container}>
    <FIcons.FForbid className={styles.FForbid} />
    <div style={{ height: 30 }} />
    <div className={styles.content}>
      {
        isOwner
          ? FI18n.i18nNext.tJSXElement('alert_nodedisable01', {
            NodeDomain: nodeName,
            DisableDetails: freezeReason,
          })
          : FI18n.i18nNext.tJSXElement('alert_nodedisable02', {
            NodeDomain: nodeName,
            DisableDetails: freezeReason,
          })
      }
    </div>
  </div>);
}

export default connect()(Freeze);
